// Modules:
import React from 'react';

// Material UI:
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

const PeriodSelector = ({
    chartDataYears,
    handleDropdownSelect,
    selection,
    styles,
    helperText = 'Select Period',
}) => (
    <>
        <FormControl sx={styles}>
            <Select
                variant="standard"
                id="period-select"
                value={selection}
                onChange={handleDropdownSelect}
            >
                {chartDataYears.map((year) => (
                    <MenuItem key={year} value={year}>
                        {year}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText id="select-by-period-text">
                {helperText}
            </FormHelperText>
        </FormControl>
    </>
);
export default PeriodSelector;
